const columns = () => ([
  {
    title: 'Company',
    key: 'company',
    width: '30%',
  },
  {
    title: 'Page Key',
    dataIndex: 'pageKey',
    key: 'pageKey',
    width: '15%',
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    ellipsis: true,
    width: '30%',
  },
  {
    title: 'Added',
    dataIndex: 'addedAt',
    key: 'addedAt',
    width: '15%',
  },
  {
    title: '',
    key: 'actions',
    width: '5%',
    align: 'center',
  },
]);

export default columns;
